export function setBrandingColor(
  key: string,
  value?: string,
  fallback: string = '7E57C2'
): void {
  const finalColor = value?.trim() || fallback;
  document.documentElement.style.setProperty(`--color-${key}`, finalColor);
}
